import { AutogenModelJournalSales, AutogenRowJournalSales } from "./autogen/AutogenModelJournalSales";


export class ModelJournalSales extends AutogenModelJournalSales<RowJournalSales> {
	constructor() {
		super(RowJournalSales);
	}
}

export class RowJournalSales extends AutogenRowJournalSales {
}